import styled from "@emotion/styled";
import Card from "components/layout/Card/Card";

export const StileDiVitaItemCardContainer = styled(Card)`
    border-top: 3px solid ${({theme}) => theme.palette.primary.light};
    border-radius: 0.3px;
    min-height: 100px;
`;